module.exports = __webpack_public_path__ + "img/padnote.4643d6f3.svg";